import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'EXECUTE_PAYMENT_POST',
  POST_SUCCESS: 'EXECUTE_PAYMENT_POST_SUCCESS',
  POST_FAILURE: 'EXECUTE_PAYMENT_POST_FAILURE',
};

export const post = actions.post((id, value) => `${BASE_URL}/payment/execute-payment/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
